// 西班牙语言
export const common = {
  cancel:"Cancelación",
  confirm:"Confirmado",
  country:"País"
};
// 订单列表页面
export const orderList = {
  title:"Lista de pedidos",
};

// 查询页面
export const cardLoop = {
  cardTitle:"Número iccid de la tarjeta SIM",
  cardDesc:"Introduzca el número iccid de la tarjeta SIM en el cuadro de entrada.",
  query:"Buscar", //查询按钮
  title:"Plataforma de tarjetas SIM IOT",
};

// 详情页面
export const cardInfo = {
  title:"Información de la tarjeta",
  msisdn:"MSISDN：",
  iccid:"ICCID：",
  expiration:"Vencimiento：",//过期时间
  status:'Estado',
  refresh:"Actualizar",//刷新
  residualFlow:"flujoResidual",//剩余流量
  totalFlow:"Total",//总流量
  used:"Usó",//已使用
  lists:["Usando","NoUsado","Usó"],//tab切换 1 生效中 2 未生效 3.已失效
  validity:"tiempo",//套餐有效期
  skuUsed:"Usó",//套餐已用
  skuTotal:"Total",//套餐总量
  recharge:"Recargar",//去充值
};


// 选套餐页面
export const cardPlans = {
  title:"Lista de paquetes",
  buyPlan:'Plan de compra',
  select:"Elige un plan",//未选套餐的提示
  orderList:"Lista de pedidos",
  userAgreement:"Protocolo de usuario",
  price:"Precio del paquete",
  flowCount:"Caudal total",
  validityTime:"Fecha de validez",
  switchCountryName:"Área disponible",
  productDesc:"Instrucciones del paquete",
  productDescText:"Pago anticipado",
  paymentMethod:"Método de pago",
  checkUserAgreementMsg:"Por favor, marque el Acuerdo de usuario",
  payErrorMsg:"La cuenta de cobro no admite pagos en RMB",
  payBtnText:"Usar",
};

// 完成支付或取消支付
export const cardPayEnd = {
  title:"Resultados del pago",
  Details:"Detalles",//返回详情
};

export const country = {
  America:'Estados unidos',
  HongKong:'Hong kong',
  Thailand:'tailandia',
  Philippines:'filipinas',
  Macao:'Macao'
}

// 位置标签
export const placeTitle = "País Anfitrión";
// 国家名称
export const China = "China"
export const America = "estados unidos"
export const HongKong = "Hong Kong"





